var React = require('react');

function Section1TopLeftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"81","cy":"50","r":"50","fill":"#D4EBF8","key":0}),React.createElement("circle",{"cx":"27","cy":"174","r":"27","fill":"#FED7D7","key":1}),React.createElement("rect",{"width":"58.991","height":"58.991","x":"36.16","y":"157.16","fill":"#45B8C1","transform":"rotate(-42 65.656 186.656)","key":2}),React.createElement("polygon",{"fill":"#F4EBFE","points":"109.388 314.16 129 370.408 89.776 370.408","transform":"rotate(159 109.388 342.284)","key":3}),React.createElement("circle",{"cx":"47","cy":"278","r":"16","fill":"#C5F6D5","key":4})]));
}

Section1TopLeftInline.defaultProps = {"width":"131","height":"369","viewBox":"0 0 131 369"};

module.exports = Section1TopLeftInline;

Section1TopLeftInline.default = Section1TopLeftInline;
